import { render, staticRenderFns } from "./UserInfoWidget.vue?vue&type=template&id=3c23cd2d"
import script from "./UserInfoWidget.vue?vue&type=script&lang=js"
export * from "./UserInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./UserInfoWidget.vue?vue&type=style&index=0&id=3c23cd2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports